import { IFeedback } from '@app/models/feedback.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { LoginService } from '../util/login.service';

/**
 * Angular HTTP Client request options including headers
 */
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: 'my-auth-token'
  })
};

@Injectable({
  providedIn: 'root'
})
export class JiraService {

  /**
   * instance of feedback service endpoint url.
   * Depending on the selected environment it
   * will point at either develop, staging or production
   */
  private url = environment.customerCareAPI;

  /**
   * Creates an instance of JiraService
   *
   * @param http used for HTTP requests
   * @param loginService used to get accessToken required for requests
   */
  constructor(
    private http: HttpClient,
    private loginService: LoginService
  ) { }

  /**
   * submitFeedback
   *
   * @returns publishes feedback to jira and teams
   */
  public submitFeedback(feedback: IFeedback): Observable<any> {
    this.updateToken();
    return this.http.post<any>(`${this.url}/submit`, feedback, httpOptions);
  }

  /**
   * updateToken sets the most upto date Auth Token in the header
   *
   */
  private updateToken(): void {
    httpOptions.headers = httpOptions.headers.set('Authorization', this.loginService.getToken());
  }
}
